import { render } from "./modal-container.vue?vue&type=template&id=6514996c&lang=pug"
import script from "./modal-container.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-container.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__